package com.klantenstop.web.pages.admin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.klantenstop.web.components.H1Heading
import com.klantenstop.web.components.layout.AdminPageLayout
import com.klantenstop.web.components.moderation.ModerationTable
import com.klantenstop.web.data.models.domain.ModerationEntry
import com.klantenstop.web.data.models.dto.responses.moderation.ModerationEntityType
import com.klantenstop.web.navigation.Navigation
import com.klantenstop.web.styles.Typography
import com.materialkobweb.utils.rememberViewModel
import com.materialkobweb.components.widgets.DsSpinner
import com.materialkobweb.components.widgets.PrimaryTextButtonLinkStyle
import com.materialkobweb.components.widgets.SpinnerSize
import com.materialkobweb.components.widgets.TextButtonLink
import com.materialkobweb.styles.MaterialColorVars
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Text

@Page("/admin")
@Composable
fun AdminHomePage() {
    val viewModel = rememberViewModel { AdminHomeViewModel() }
    val state by viewModel.state.collectAsState()

    AdminPageLayout(title = "Home") {
        AdminHomeContent(state = state)
    }

}

@Composable
fun AdminHomeContent(state: AdminHomeContract.State) {
    val breakpoint = rememberBreakpoint()

    Column(
        modifier = Modifier
            .fillMaxWidth(if (breakpoint > Breakpoint.MD) 80.percent else 90.percent)
            .fillMaxHeight()
            .maxWidth(1000.px)
            .padding(leftRight = 24.px, topBottom = 58.px),
        verticalArrangement = Arrangement.spacedBy(60.px)
    ) {
        H1Heading(
            modifier = Modifier,
            typography = Typography.HeadlineSmall,
            text = "Moderatie wachtrij",
            color = MaterialColorVars.Primary.value()
        )

        ModerationQueueSection(
            title = "Bedrijven",
            entityType = ModerationEntityType.COMPANY,
            items = state.companyItems,
            total = state.companyTotal,
            isLoading = state.isLoadingCompanies,
            error = state.companyError,
        )

        ModerationQueueSection(
            title = "Statussen",
            entityType = ModerationEntityType.STATUS,
            items = state.statusItems,
            total = state.statusTotal,
            isLoading = state.isLoadingStatuses,
            error = state.statusError,
        )

        ModerationQueueSection(
            title = "Beoordelingen",
            entityType = ModerationEntityType.REVIEW,
            items = state.reviewItems,
            total = state.reviewTotal,
            isLoading = state.isLoadingReviews,
            error = state.reviewError,
        )
    }
}

@Composable
private fun ModerationQueueSection(
    title: String,
    entityType: ModerationEntityType,
    items: List<ModerationEntry>,
    total: Long,
    isLoading: Boolean,
    error: String?,
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(12.px)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                text = title,
                modifier = Modifier
                    .fontSize(20.px)
                    .fontWeight(FontWeight.SemiBold)
                    .color(MaterialColorVars.OnSurface.value())
            )

            TextButtonLink(
                path = Navigation.Screen.Admin.ModerationQueue(entityType).route,
                variant = PrimaryTextButtonLinkStyle
            ) {
                Text("Bekijk alles ($total)")
            }
        }

        Box(
            modifier = Modifier.fillMaxWidth(),
            contentAlignment = if (isLoading) Alignment.Center else Alignment.TopStart
        ) {
            when {
                isLoading -> DsSpinner(size = SpinnerSize.Normal)

                error != null -> SpanText(
                    text = error,
                    modifier = Modifier.fontSize(14.px).color(MaterialColorVars.Error.value())
                )

                else -> ModerationTable(items = items)
            }
        }
    }
}
